import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

const TIME_FORMAT_ERROR = 'Invalid format. Required time format is hours:minutes. E.g. 72:42';
const HOURS_MINUTES_PATTERN = '^\\d{1,10}:\\d{2}$';

export const handleDelayValidations = form => {
    const errors = {};

    if (!moment(form.abnormalityDate).isValid()) {
        errors.selectedDate = 'You must provide a valid date.';
    }

    if (isEmpty(form.currentDelay)) {
        errors.currentDelay = 'You must provide a current delay.';
    }

    if (form.currentDelay && !form.currentDelay.match(HOURS_MINUTES_PATTERN)) {
        errors.currentDelay = TIME_FORMAT_ERROR;
    }

    if (!moment(form.etaToEmc).isValid()) {
        errors.etaToEmc = 'You must provide a valid ETA to CD/EMC.';
    }

    if (isEmpty(form.etaToEmc)) {
        errors.etaToEmc = 'You must provide an ETA to CD/EMC.';
    }

    if (!isEmpty(form.driverTimeLeft) && !form.driverTimeLeft.match(HOURS_MINUTES_PATTERN)) {
        errors.driverTimeLeft = TIME_FORMAT_ERROR;
    }

    if (!isEmpty(form.driverWorkingTime) && !form.driverWorkingTime.match(HOURS_MINUTES_PATTERN)) {
        errors.driverWorkingTime = TIME_FORMAT_ERROR;
    }

    return errors;
};
